import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

const CheckboxComponent = ({ item, list, clickCheckbox }) => {
  return (
    <>
      <Checkbox
        onChange={(e) => clickCheckbox(e)}
        className="normal"
        checked={list?.filter((chk) => chk === item.key).length === 1}
      >
        {item.value}
      </Checkbox>
      <br />
    </>
  );
};

// PropTypes tanımlaması
CheckboxComponent.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  list: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  clickCheckbox: PropTypes.func.isRequired,
};

export default CheckboxComponent;
